﻿import '../../css/src/global52.scss';

import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jquery-ajax-unobtrusive';
import 'popper.js';
import 'bootstrap';

//import '../lib/bootsnav';
//import '../lib/modern-megamenu';
//import '../lib/jquery.mmenu';
import '../lib/slick.min';
import '../lib/autoComplete';
import '../lib/jquery.lazy';
//import '../lib/video'; // makes web pack complain about file size

import * as Main from './main';
import * as Address from './address';
import * as Ecommerce from './ecommerce';
import * as BuildYourOwn from './byo.js';
import * as Validation from './validation';
import * as Facets from './facets';

//console.log('I am Derwent');

//Ecommerce.hello();